import { getAnonymousId, sanitizeTextForAnalytics, shaEncrypt } from "@/utils/helper"
import _isEmpty from "lodash/isEmpty"
import cloneDeep from "lodash/cloneDeep"
import { getAnalyticLinkUrl } from "@/utils/helper"

const getEventInfo = (type, needJson = false) => {
  const eventInfo = {
    eventAction: `my account:orders:order details:${type}`,
    eventName: `my account:orders:order details:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "my orders",
    internalLinkType: `my account:${type}`,
    internalLinkZoneName: "my account:orders:order details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

const getAccountType = accountType =>
  accountType === "homeowner" ? "homeowner account" : "professional account"

const getEventInfoForSignupPromotionalLinks = (url, type, accountType) => {
  const account = getAccountType(accountType)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `order confirmation:create an account form:${type}`,
    eventMsg: "n/a",
    eventName: `order confirmation:create an account form:${type}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: type,
    internalLinkPosition: "order-confirmation",
    internalLinkType: `order confirmation:${account}`,
    internalLinkURL: url,
    internalLinkZoneName: "order confirmation:create an account",
  }

  return JSON.stringify(eventInfo)
}

const addAnalyticsForCreateAccount = (
  newsletterSignUp,
  accountType,
  url,
  eventStatus,
  message = "",
  email
) => {
  const account = getAccountType(accountType)
  const internalLinkURL = url ? `${window.location.origin}${url}` : "n/a"
  const eventMsg = message ? sanitizeTextForAnalytics(message) : "n/a"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `order confirmation:${account}:create an account form`,
    eventMsg,
    eventName: `order confirmation:${account}:create an account form`,
    eventStatus,
    eventType: "navigation",
    internalLinkName: "create an account",
    internalLinkPosition: "order-confirmation",
    internalLinkType: `order confirmation:${account}`,
    internalLinkURL,
    internalLinkZoneName: "order confirmation:create an account",
    newsletterSignUp,
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const cloneObject = cloneDeep(page)
  const base64Str = Buffer.from(email).toString("base64")
  cloneObject.user.commerceToolsID = base64Str
  cloneObject.user.emailId = base64Str
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", cloneObject)
}

const addAnalyticsForPasswordRequirementsLink = (
  accountType,
  isForOneClick = false
) => {
  const type = isForOneClick ? "order confirmation" : "my account modal section"
  const account = getAccountType(accountType)

  const internalLinkType = isForOneClick
    ? `order-confirmation:${account}`
    : "my account:navigation"

  const internalLinkZoneName = isForOneClick
    ? "order confirmation:create an account"
    : "my account:modal:sign in form"

  const internalLinkPosition = isForOneClick
    ? "order-confirmation"
    : "auth modal"

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${type}:${account}:password requirements`,
    eventMsg: "n/a",
    eventName: `${type}:${account}:password requirements`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "password requirements",
    internalLinkPosition,
    internalLinkType,
    internalLinkURL: "n/a",
    internalLinkZoneName,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const addAnalyticsgoToAccount = accountPage => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: "order:thank you: account",
    eventName: "order:thank you: account",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "account",
    internalLinkPosition: "order confirmation",
    internalLinkType: "order:navigation",
    internalLinkURL: accountPage,
    clickInternalLinks: "true",
    internalLinkZoneName: "order:thank you:order confirmation",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsOrderDetailConfirmation = orderPage => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction:
      "orders:order confirmation:thank you for your order:view order details",
    eventName:
      "orders:order confirmation:thank you for your order:view order details",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view order details",
    internalLinkPosition: "order confirmation",
    internalLinkType: "order:navigation",
    internalLinkURL: orderPage,
    clickInternalLinks: "true",
    internalLinkZoneName: "orders:order confirmation:thank you for your order",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const printOrderDetailConfirmation = () => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction:
      "orders:order confirmation:thank you for your order:print order details",
    eventName:
      "orders:order confirmation:thank you for your order:print order details",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "print order details",
    internalLinkPosition: "order confirmation",
    internalLinkType: "order:navigation",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    internalLinkZoneName: "orders:order confirmation:thank you for your order",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const addAnalyticsAccountSelection = accountType => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: `order confirmation: create a quick account: ${accountType}`,
    eventName: `order confirmation: create a quick account: ${accountType}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: accountType,
    internalLinkPosition: "order confirmation",
    internalLinkType: "order confirmation:create a quick account:navigation",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    internalLinkZoneName:
      "order confirmation:thank you: create a quick account",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
const pushAnalyticsObjToDataLayer = (
  eventInfo = {},
  event = "cmp:click",
  modifiedPageObj = {}
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page: !_isEmpty(modifiedPageObj) ? modifiedPageObj : page,
  })
}

export const downloadInvoiceAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "my account:orders:order details:download invoice",
    eventName: "my account:orders:order details:download invoice",
    eventType: "navigation",
    internalLinkName: "download invoice",
    internalLinkPosition: "order details",
    internalLinkType: "my account:download",
    internalLinkURL: "n/a",
    internalLinkZoneName: "my account:orders:order details",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const orderSupportLinkAnalytics = (text, link) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:order summary:${text}`,
    eventName: `my account:orders:order summary:${text}`,
    eventType: "navigation",
    internalLinkName: text,
    internalLinkPosition: "order details",
    internalLinkType: "my account:order support",
    internalLinkURL: getAnalyticLinkUrl(link),
    internalLinkZoneName: "my account:orders:order summary",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const orderEmailUsAnalytics = (text, link, isEmail = true) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:order summary:customer support ${
      isEmail ? "email id" : "phone number"
    }`,
    eventName: `my account:orders:order summary:customer support ${
      isEmail ? "email id" : "phone number"
    }`,
    eventType: "navigation",
    internalLinkName: text,
    internalLinkPosition: "order details",
    internalLinkType: "my account:customer support",
    internalLinkURL: link,
    internalLinkZoneName: "my account:orders:order summary",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
const generateEventId=() =>{
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export const gtmPurchaseEvent = async (id, email, address = {}, total, _appliedCouponCode="") => {
  const eventId=generateEventId()
  if (typeof window !== undefined && window.dataLayer) {
    const { phone, firstName, lastName, streetName, city, region, postalCode } =
      address

    window.dataLayer.push({
      event: "ec_purchase",
      event_id: eventId,
      email,
      sha256_email_address: await shaEncrypt(email),
      phone_number: `+91${phone}`,
      sha256_phone_number: await shaEncrypt(phone),
      address: {
        first_name: firstName,
        sha256_first_name: await shaEncrypt(firstName),
        last_name: lastName,
        sha256_last_name: await shaEncrypt(lastName),
        street: streetName,
        city: city,
        region: region,
        postal_code: postalCode,
        country: "IN",
      },
      order_value: total,
      order_id: id,
      coupon_code: _appliedCouponCode
    })
  const eventTime = Math.floor(Date.now() / 1000);
  const anonymousId = getAnonymousId()
  const oktaToken = localStorage.getItem("okta-token-storage")
  let emailId=""
  if (oktaToken && oktaToken !== "{}") {
    const oktaObject = JSON.parse(oktaToken)
    const claim = oktaObject?.accessToken?.claims || {}
    emailId=claim?.sub
  }
  await fetch(
    `https://graph.facebook.com/v25.0/${process.env.NEXT_PUBLIC_META_PIXEL_ID}/events?access_token=${process.env.NEXT_PUBLIC_META_ACCESS_TOKEN}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [
          {
            event_name: 'Purchase',
            event_time: eventTime,
            event_id: eventId,
            action_source: 'website',
           "user_data": { 
              "client_user_agent": navigator.userAgent,
              em: [await shaEncrypt(emailId.toLowerCase())],
            },
            custom_data: {
              email,
              sha256_email_address: await shaEncrypt(email),
              phone_number: `+91${phone}`,
              sha256_phone_number: await shaEncrypt(phone),
              address: {
                first_name: firstName,
                sha256_first_name: await shaEncrypt(firstName),
                last_name: lastName,
                sha256_last_name: await shaEncrypt(lastName),
                street: streetName,
                city: city,
                region: region,
                postal_code: postalCode,
                country: "IN",
              },
              order_value: total,
              order_id: id,
              coupon_code: _appliedCouponCode
            },
          },
        ],
      }),
    }
  );
  }
}

const calDisBasePriceLineItm = (item_cent, discountedBasePrice, couponDiscount) => {
  const item_price_rupee = item_cent.price?.value?.centAmount / 100
  if(couponDiscount > 0) {
    const basePrice = discountedBasePrice + couponDiscount
    const discount_percentage = (couponDiscount/ basePrice) * 100
    return (item_price_rupee - ((item_price_rupee * discount_percentage) / 100))
  } else {
    return item_price_rupee
  }
}

export const adobePurchaseEvent = async rsp => {
  const _discountedBasePrice = (rsp?.totalPrice?.centAmount) / 100
  const _couponDiscount = (rsp?.discountOnTotalPrice?.discountedAmount?.centAmount) / 100
  const getAttr = (product, key) => {
    const data = product.variant.attributes.find(item => item.name === key)
    return data?.value
  }
  const eventInfo = {
    orderID: rsp.id,
    orderNumber: rsp.orderNumber,
    price: {
      basePrice: _discountedBasePrice,
      voucherCode: "n/a",
      voucherDiscount: 0,
      globalOffer: "n/a",
      globalDiscount: 0,
      currency: "inr",
      taxRate: 0,
      shipping: 0,
      priceWithTax: rsp.totalPrice?.centAmount / 100,
      cartTotal: rsp.totalPrice?.centAmount / 100,
      couponCode: "n/a",
      couponDiscount: _couponDiscount,
      orderCouponCode: "n/a",
      orderCouponDiscount: 0,
      shippingMethod: "standard",
    },
    item: rsp.lineItems?.map(item => ({
      productInfo: {
        productBrand: "kohler-india",
        productID: item.variant?.sku,
        description: getAttr(item, "ProductDescriptionProduct"),
        productCategory: getAttr(item, "ProductLocalCategory"),
        productName: getAttr(item, "ProductBrandNameDisplay"),
        productColor: "thunder grey",
        productRoom: "non-catalog",
        productSaleable: true,
        productStatus: "in stock",
        productPartnerBuyNow: false,
        productBasePrice: calDisBasePriceLineItm(item, _discountedBasePrice, _couponDiscount),
        productCouponCode: "n/a",
        productCoupondiscount: 0,
        productSuperSku: false,
        productSalePrice: item.price?.value?.centAmount / 100,
        globalPromotionPrice: item.price?.value?.centAmount / 100,
        priceState: "regular price",
        productCollectionsName: getAttr(item, "ProductBrandName"),
        productFindingMethod: "n/a",
        productTileName: getAttr(item, "ProductBrandName"),
        quantity: item.quantity,
        globalOffer: "n/a",
        globalDiscount: 0,
        itemType: "product",
        isSubscription: false,
        isRecommended: false,
        frequency: "n/a",
        isSendNow: "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
      },
      quantity: item.quantity,
    })),
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:purchase")
}

export {
  getEventInfo,
  addAnalyticsForCreateAccount,
  getEventInfoForSignupPromotionalLinks,
  addAnalyticsForPasswordRequirementsLink,
}
